<template>
  <div class="content-div">
    <div>
      <label class="study-unit-label">{{ study_unit.name }}</label>
      <p>
        <!-- <b-icon
          v-if="getRaMicro(study_unit.id)"
          :id="`ra-micro-content-${study_unit.id}`"
          class="ra-micro-icon"
          style="cursor: pointer"
          icon="info-circle"
        ></b-icon> -->
        <template v-if="institution && institution.show_competence_unit">
          <div class="d-flex">
            <SentenceContainer :Sentence="study_unit">
              <template #order>
                <strong>
                  <span>
                    {{ getCompetenceUnitOrder(study_unit.temp_competence_unit)
                    }}{{ study_unit.order }}
                  </span>
                </strong>
              </template>
            </SentenceContainer>
          </div>
        </template>
        <template v-else>
          <SentenceContainer :Sentence="study_unit">
            <template #order>
              <strong>
                <span>
                  {{ study_unit.order }}
                </span>
              </strong>
            </template>
          </SentenceContainer>
        </template>
      </p>
      <div>
        <section>
          <!-- <SentenceContainer :Sentence="getRaMicro(study_unit.id)">
              </SentenceContainer> -->
        </section>
      </div>
      <div
        class="d-flex justify-content-center"
        v-can="'teaching.change_studyunit'"
        v-if="allows_crud"
      >
        <template
          v-if="storedStudyUnit && !storedStudyUnit.study_unit_locked_view"
        >
          <LinkingCompetenceToRa
            v-if="institution && institution.show_base_ra"
            class="noprint"
            :study_unit_id="study_unit_id"
            :egress_profile_matter_id="egress_profile_matter_id"
            :allows_crud="allows_crud && can_update"
          ></LinkingCompetenceToRa>
        </template>
        <!-- class="button-div" -->
        <ButtonSmall
          v-if="can_update && allows_crud"
          :tooltip_text="`Editar ${$getVisibleNames(
            'teaching.ramicro',
            false,
            'RA Micro'
          )}`"
          :click_button="openModalStudyUnit"
          :icon="'square'"
        ></ButtonSmall>
        <b-modal
          :id="`edit-study-unit-modal-${study_unit.id}`"
          :title="`Editar ${$getVisibleNames(
            'teaching.ramicro',
            false,
            'RA Micro'
          )}`"
          size="lg"
          hide-footer
          ignore-enforce-focus-selector="#sidebar-right"
          @hide="hideModaltoMatterProgram()"
        >
          <!-- <p>El Indicador de Desempeño o Aprendizaje Esperado de la Asignatura constituye el último Resultado de Aprendizaje (Unidad de Aprendizaje) de la Asigntura.</p> -->
          <StudyUnitForm
            :egress_profile_matter_id="egress_profile_matter_id"
            :matter_id="matter_id"
            :StudyUnit="study_unit"
            :show_delete_button="can_delete"
            :show_temp_competence_unit="true"
            :can_update="can_update"
            :can_delete="can_delete"
            @updated="$bvModal.hide(`edit-study-unit-modal-${study_unit.id}`)"
            @deleted="$bvModal.hide(`edit-study-unit-modal-${study_unit.id}`)"
          ></StudyUnitForm>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { generateUniqueId } from "@/utils/utils";

export default {
  name: "StudyUnitCell",
  components: {
    LinkingCompetenceToRa: () =>
      import("@/components/mesh/Matrix2/LinkingCompetenceToRa"),
    StudyUnitForm: () => import("@/components/reusable/StudyUnitForm"),
    SentenceContainer: () => import("@/components/reusable/SentenceContainer"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
  },
  props: {
    study_unit_id: {
      type: [Number, String],
      default: function () {
        return generateUniqueId();
      },
    },
    matter_id: {
      type: Number,
      required: true,
    },
    egress_profile_matter_id: {
      type: Number,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
    can_update: {
      type: Boolean,
      default: false,
    },
    can_delete: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      study_unit: {
        id: this.study_unit_id,
        name: "",
        order: 1,
        weeks: 6,
        matter: this.matter_id,
        methodological_strategies: [],
        performance_indicators: [],
        action: "",
        content: "",
        condition: "",
        verb: null,
      },
    };
  },
  methods: {
    getRaMicro(study_unit_id) {
      const ra = this.ra_micros.find((x) => x.study_unit == study_unit_id);
      return ra ? ra : null;
    },
    getCompetenceUnitOrder(competence_unit_id) {
      const competence_unit = this.competence_units.find(
        (x) => x.id == competence_unit_id
      );
      return competence_unit ? competence_unit.order + "." : null;
    },
    openModalStudyUnit() {
      this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
      this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);

      if (this.profileMatter) {
        this.$nextTick(() => {
          this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
            egress_profile_id: this.profileMatter.egress_profile,
            egress_profile_matter_id: this.egress_profile_matter_id,
            intelligence_option: 2,
          });
          this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
            visible_intelligence_options:
              this.institution && this.institution.internal_use_id == "duoc.cl"
                ? [2, 7]
                : [2],
            disabled_selected_egress_profile: true,
            disabled_selected_egress_profile_matter: true,
          });
        });
      }
      this.$bvModal.show(`edit-study-unit-modal-${this.study_unit.id}`);
    },

    hideModaltoMatterProgram() {
      this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
      this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);

      if (this.profileMatter) {
        this.$nextTick(() => {
          this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
            egress_profile_id: this.profileMatter.egress_profile,
            egress_profile_matter_id: null,
            competence_unit_id: null,
            intelligence_option: 2,
          });
          this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
            visible_intelligence_options: [2, 4, 5, 6, 7],
            disabled_selected_egress_profile: true,
            disabled_selected_study_unit: null,
            disabled_selected_competence_unit: null,
          });
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      studyUnits: names.STUDY_UNITS,
      ra_micros: names.RA_MICROS,
      competence_units: names.COMPETENCE_UNITS,
      egressProfileMatters: names.EGRESS_PROFILES_MATTERS,
    }),
    profileMatter() {
      return this.egressProfileMatters.find(
        (x) => x.id == this.egress_profile_matter_id
      );
    },
    storedStudyUnit() {
      return this.studyUnits.find((x) => x.id == this.study_unit_id);
    },
  },
  mounted() {
    if (this.storedStudyUnit) this.study_unit = this.storedStudyUnit;
  },
  watch: {
    storedStudyUnit() {
      if (this.storedStudyUnit) this.study_unit = this.storedStudyUnit;
    },
  },
};
</script>

<style scoped>
p {
  font-size: var(--thirth-font-size);
  text-align: left;
}
.button-div {
  width: 100%;
  position: absolute;
  bottom: 0;
}
.content-div {
  margin-bottom: 25px;
}
.ra-micro-icon {
  float: right;
  transform: translateX(60%);
  margin-top: 1em;
  margin-right: 1em;
}
.study-unit-label {
  font-size: var(--secondary-font-size);
  margin-bottom: 0.3em;
  display: block;
  text-align: left;
  margin-left: 0.5em;
  font-weight: bold;
}
</style>